// Single-candidate request types (each has its own request page, approval page and permissions).
export const REQUEST_TYPES = {
  passport: { label: 'Passport' },
  accommodation: { label: 'Accommodation' },
};
